document.addEventListener('DOMContentLoaded', () => {
  const showRevealFallback = () => {
    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach((target) => {
      target.classList.add('is-visible');
    });
  };

  try {
  // Keep content visible even if reveal observer does not run on some mobile browsers.
  showRevealFallback();
  // Redirect /collections/all?filter.p.vendor=Brand -> /collections/brand?sort_by=best-selling
  const normalize = (v) => String(v || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const brandMap = {
    rolex: 'rolex',
    'patek-philippe': 'patek-philippe',
    'audemars-piguet': 'audemars-piguet',
    cartier: 'cartier',
    omega: 'omega',
    panerai: 'panerai',
    'richard-mille': 'richard-mille',
    'vacheron-constantin': 'vacheron-constantin',
    tudor: 'tudor'
  };

  const url = new URL(window.location.href);
  const path = window.location.pathname.replace(/\/+$/, '');
  const vendor = url.searchParams.get('filter.p.vendor');
  const hasTagFilter = url.searchParams.has('filter.p.tag');

  // Force best-selling sort on collection pages when sort param is missing
  if (path.startsWith('/collections/') && !url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(window.location.pathname + "?" + url.searchParams.toString());
    return;
  }

  if (path === '/collections/all' && vendor && !hasTagFilter) {
    const key = normalize(vendor);
    const handle = brandMap[key] || key;
    const sortBy = url.searchParams.get('sort_by') || 'best-selling';
    window.location.replace(`/collections/${handle}?sort_by=${encodeURIComponent(sortBy)}`);
    return;
  }

  const toHandle = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const brandCollectionAliases = {
    rolex: 'rolex',
    'patek-philippe': 'patek-philippe',
    'patek-philipe': 'patek-philippe',
    patek: 'patek-philippe',
    'audemars-piguet': 'audemars-piguet',
    audemars: 'audemars-piguet',
    ap: 'audemars-piguet',
    'a-p': 'audemars-piguet',
    cartier: 'cartier',
    omega: 'omega',
    tudor: 'tudor',
    panerai: 'panerai',
    'richard-mille': 'richard-mille',
    'vacheron-constantin': 'vacheron-constantin'
  };

  const normalizeCollectionPath = (value, fallback = '/collections/all') => {
    const cleanPath = String(value || '').trim().split('?')[0].replace(/\/+$/, '');
    if (!cleanPath) return fallback;
    if (cleanPath.startsWith('/collections/')) return cleanPath;
    return fallback;
  };

  const getBrandCollectionPath = (value) => {
    const handle = toHandle(value);
    const collectionHandle = brandCollectionAliases[handle] || '';
    return collectionHandle ? `/collections/${collectionHandle}` : '';
  };

  const appendTagHandle = (value, selectedTagHandles) => {
    const tagHandle = toHandle(value);
    if (!tagHandle || selectedTagHandles.includes(tagHandle)) return;
    selectedTagHandles.push(tagHandle);
  };

  // Rewrite legacy tag query params to collection/tag path URLs
  if (window.location.pathname.startsWith('/collections/')) {
    const normalizedPath = normalizeCollectionPath(window.location.pathname, '/collections/all');
    const onCollectionRootPath = /^\/collections\/[^/]+$/.test(normalizedPath);
    const currentUrl = new URL(window.location.href);
    const legacyTagValues = currentUrl.searchParams
      .getAll('filter.p.tag')
      .map((value) => String(value || '').trim())
      .filter(Boolean);

    if (onCollectionRootPath && legacyTagValues.length) {
      const legacyTagHandles = [];
      legacyTagValues.forEach((value) => {
        value.split(',').forEach((tag) => appendTagHandle(tag, legacyTagHandles));
      });

      if (legacyTagHandles.length) {
        let rewrittenPath = `${normalizedPath}/${legacyTagHandles.join('+')}`;
        const brandCollectionPath = getBrandCollectionPath(legacyTagHandles[0]);

        if (brandCollectionPath) {
          rewrittenPath = brandCollectionPath;
          if (legacyTagHandles.length > 1) {
            rewrittenPath += `/${legacyTagHandles.slice(1).join('+')}`;
          }
        }

        currentUrl.searchParams.delete('filter.p.tag');
        const rewrittenQuery = currentUrl.searchParams.toString();
        const rewrittenUrl = `${rewrittenPath}${rewrittenQuery ? `?${rewrittenQuery}` : ''}`;
        const currentPathWithQuery = `${window.location.pathname}${window.location.search}`;

        if (rewrittenUrl !== currentPathWithQuery) {
          window.location.replace(rewrittenUrl);
          return;
        }
      }
    }
  }

  // Collection/Product filter form
	  document.querySelectorAll('[data-product-filter-form]').forEach((form, formIndex) => {
	    let keywordInput = form.querySelector('[data-product-keyword]');
	    const initialBrandSelect = form.querySelector('[data-product-brand-filter]');
	    const inlineFilterRow = form.querySelector('.collection-inline-filter-form');
	    const gridFilterRow = form.querySelector('.product-filter-grid, .collection-filter-group-selects');

    if (!keywordInput) {
      if (inlineFilterRow) {
        keywordInput = document.createElement('input');
        keywordInput.type = 'search';
        keywordInput.name = 'q';
        keywordInput.placeholder = 'Keyword';
        keywordInput.className = 'collection-filter-select collection-keyword-input';
        keywordInput.setAttribute('data-product-keyword', '');
        keywordInput.setAttribute('data-product-query-param', '');
        inlineFilterRow.appendChild(keywordInput);
      } else if (gridFilterRow) {
        const inputId = `CollectionKeyword-${formIndex}`;
        const keywordField = document.createElement('div');
        keywordField.className = 'collection-keyword-wrap';
        keywordField.innerHTML = `
          <label for="${inputId}">Keyword</label>
          <input id="${inputId}" type="search" name="q" placeholder="Search keyword" class="collection-filter-select collection-keyword-input" data-product-keyword data-product-query-param>
        `;
        gridFilterRow.prepend(keywordField);
        keywordInput = keywordField.querySelector('[data-product-keyword]');
      }
    }

	    const syncKeywordFromUrl = () => {
	      if (!keywordInput) return;
	      const q = String(new URL(window.location.href).searchParams.get('q') || '').trim();
	      if (q && !keywordInput.value.trim()) keywordInput.value = q;
	    };

	    const getUrlKeyword = () => String(new URL(window.location.href).searchParams.get('q') || '').trim().toLowerCase();
	    const allowLiveKeywordFilter = !window.location.pathname.startsWith('/collections/all/');

	    if (initialBrandSelect && initialBrandSelect.dataset.initialValue == null) {
	      initialBrandSelect.dataset.initialValue = String(initialBrandSelect.value || '').trim();
	    }

	    const runLocalKeywordFilter = () => {
	      if (!keywordInput) return;
	      const term = keywordInput.value.trim().toLowerCase();
	      const scope = form.closest('.main-collection-section, .main-product-section') || document;
	      const cards = scope.querySelectorAll('.collection-grid .product-card');
	      if (!cards.length) return;

	      let visibleCount = 0;
	      cards.forEach((card) => {
	        const title = String(card.dataset.productTitle || '').toLowerCase();
	        const handle = String(card.dataset.productHandle || '').toLowerCase();
	        const text = String(card.textContent || '').toLowerCase();
	        const haystack = `${title} ${handle} ${text}`;
	        const match = !term || haystack.includes(term);
	        card.style.display = match ? '' : 'none';
	        if (match) visibleCount += 1;
	      });

	      const pagination = scope.querySelector('.collection-pagination');
	      if (pagination) pagination.style.display = '';

      const emptyState = scope.querySelector('.collection-empty-state');
      if (emptyState) emptyState.style.display = visibleCount === 0 ? '' : 'none';
    };

	    syncKeywordFromUrl();
	    if (allowLiveKeywordFilter) {
	      keywordInput?.addEventListener('input', runLocalKeywordFilter);
	    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const baseUrl = form.dataset.baseUrl || '/collections/all';
      const basePath = normalizeCollectionPath(baseUrl, '/collections/all');
      let collectionPath = basePath;
      const selectedTagHandles = [];
      const queryParams = new URLSearchParams();

	      const brandSelect = form.querySelector('[data-product-brand-filter]');
	      const selectedBrandOption = brandSelect ? brandSelect.options[brandSelect.selectedIndex] : null;
	      const brandValue = String(brandSelect?.value || '').trim();
	      const initialBrandValue = String(brandSelect?.dataset.initialValue || '').trim();
	      const brandChanged = brandSelect ? brandValue !== initialBrandValue : false;
	      const optionCollectionPath = normalizeCollectionPath(selectedBrandOption?.dataset.collectionUrl || '', '');
	      const mappedBrandCollectionPath = getBrandCollectionPath(brandValue);

	      if (brandChanged && optionCollectionPath) {
	        collectionPath = optionCollectionPath;
	      } else if (brandChanged && mappedBrandCollectionPath) {
	        collectionPath = mappedBrandCollectionPath;
	      } else if (brandChanged && brandValue) {
	        appendTagHandle(brandValue, selectedTagHandles);
	      }

      form.querySelectorAll('[data-product-tag-filter]').forEach((select) => {
        appendTagHandle(select.value, selectedTagHandles);
      });

      form.querySelectorAll('[data-product-query-param]').forEach((field) => {
        const key = String(field.name || '').trim();
        const value = String(field.value || '').trim();
        if (!key || !value) return;
        queryParams.set(key, value);
      });

	      const keywordValue = String(keywordInput?.value || '').trim();
	      if (keywordValue) {
	        const keywordTagHandle = toHandle(keywordValue);
	        if (keywordTagHandle) {
	          collectionPath = `/collections/all/${keywordTagHandle}`;
	        } else {
	          queryParams.set('q', keywordValue);
	        }
	      }

      let finalUrl = collectionPath;
      if (selectedTagHandles.length) finalUrl += `/${selectedTagHandles.join('+')}`;

      const stockSelect = form.querySelector('[data-product-stock]');
      if (stockSelect) {
        if (stockSelect.value === 'in-stock') {
          queryParams.set('filter.v.availability', '1');
        } else if (stockSelect.value === 'out-of-stock') {
          queryParams.set('filter.v.availability', '0');
        }
      }

      const queryString = queryParams.toString();
      if (queryString) finalUrl += `?${queryString}`;
      window.location.assign(finalUrl);
    });

	    const hasUrlKeyword = !!getUrlKeyword();
	    if (allowLiveKeywordFilter && keywordInput && keywordInput.value.trim() && !hasUrlKeyword) {
	      runLocalKeywordFilter();
	    }
	  });

  // Product gallery thumbs
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-gallery-main-image');
    const thumbButtons = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
    if (!mainImage || !thumbButtons.length) return;

    const setActiveThumb = (activeThumb) => {
      thumbButtons.forEach((thumb) => {
        const isActive = thumb === activeThumb;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    thumbButtons.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const imageUrl = thumb.dataset.imageUrl;
        if (!imageUrl) return;

        const imageSrcset = thumb.dataset.imageSrcset;
        const imageAlt = thumb.dataset.imageAlt || mainImage.getAttribute('alt') || '';

        mainImage.setAttribute('src', imageUrl);
        if (imageSrcset) {
          mainImage.setAttribute('srcset', imageSrcset);
        } else {
          mainImage.removeAttribute('srcset');
        }
        mainImage.setAttribute('alt', imageAlt);

        setActiveThumb(thumb);
      });
    });

    const initialThumb = thumbButtons.find((thumb) => thumb.classList.contains('is-active')) || thumbButtons[0];
    if (initialThumb) setActiveThumb(initialThumb);
  });

  // Header/menu
  const header = document.querySelector('.site-header');
  const toggle = document.querySelector('[data-mobile-toggle]');
  const navButtons = document.querySelectorAll('[data-nav-button]');
  const desktopNavQuery = window.matchMedia('(min-width: 901px)');

  if (header) header.classList.add('nav-click-only');

  const clearMegaMenuPanels = (menu) => {
    if (!menu) return;
    const activeMainButtons = menu.querySelectorAll('.mega-main-btn.is-active');
    const activePanels = menu.querySelectorAll('.mega-sub-panel.is-active');

    activeMainButtons.forEach((button) => {
      button.classList.remove('is-active');
      button.setAttribute('aria-expanded', 'false');
    });

    activePanels.forEach((panel) => panel.classList.remove('is-active'));
    menu.classList.remove('has-active');
  };

  const clearMegaPanels = () => {
    if (!header) return;
    const megaMenus = header.querySelectorAll('[data-mega-menu]');
    megaMenus.forEach((menu) => clearMegaMenuPanels(menu));
  };

  const setMegaPanel = (menu, key) => {
    if (!menu || !key) return;
    const mainButtons = menu.querySelectorAll('.mega-main-btn');
    const panels = menu.querySelectorAll('.mega-sub-panel');

    mainButtons.forEach((button) => {
      const active = button.dataset.megaMain === key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-expanded', String(active));
    });

    panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.megaPanel === key);
    });
    menu.classList.add('has-active');
  };

  const activateDefaultMegaPanel = (item) => {
    if (!item) return;
    const megaMenu = item.querySelector('[data-mega-menu]');
    if (!megaMenu) return;
    if (megaMenu.querySelector('.mega-sub-panel.is-active')) return;

    const firstMainButton = megaMenu.querySelector('.mega-main-btn[data-mega-main]');
    if (!firstMainButton) return;

    setMegaPanel(megaMenu, firstMainButton.dataset.megaMain);
  };

  const closeDropdowns = () => {
    if (!header) return;
    const openItems = header.querySelectorAll('.nav-item.is-open');
    openItems.forEach((item) => {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-nav-button]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    clearMegaPanels();
  };

  if (header && toggle) {
    toggle.addEventListener('click', () => {
      header.classList.toggle('is-open');
      const expanded = header.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', String(expanded));
      if (!expanded) closeDropdowns();
    });
  }

  navButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const item = button.closest('.nav-item');
      if (!item || !header) return;

      const isMobileNav = !desktopNavQuery.matches;
      const hasDropdown = item.classList.contains('has-dropdown') || item.classList.contains('has-mega');

      if (button.tagName === 'BUTTON' || hasDropdown || isMobileNav) {
        event.preventDefault();
      }

      const willOpen = !item.classList.contains('is-open');
      closeDropdowns();
      item.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', String(willOpen));

      if (willOpen) activateDefaultMegaPanel(item);
    });
  });

  if (header) {
    const topLinks = header.querySelectorAll('.main-nav > .nav-item > .main-nav-link:not(.nav-button)');
    topLinks.forEach((link) => {
      link.addEventListener('click', () => closeDropdowns());
    });

    header.addEventListener('mouseleave', () => {
      if (!desktopNavQuery.matches) return;
      closeDropdowns();
    });
  }

  const megaMenus = document.querySelectorAll('[data-mega-menu]');
  megaMenus.forEach((menu) => {
    const mainButtons = menu.querySelectorAll('.mega-main-btn');
    if (!mainButtons.length) return;

    mainButtons.forEach((button) => {
      const key = button.dataset.megaMain;

      button.addEventListener('mouseenter', () => {
        if (!desktopNavQuery.matches) return;
        setMegaPanel(menu, key);
      });

      button.addEventListener('focus', () => setMegaPanel(menu, key));
      button.addEventListener('click', () => setMegaPanel(menu, key));
    });

    menu.addEventListener('mouseleave', () => {
      if (!desktopNavQuery.matches) return;
      clearMegaMenuPanels(menu);
    });
  });

  // Brand links (menu + shop-by-brand cards)
  const brandMenuHandleMap = {
    rolex: 'rolex',
    'patek-philippe': 'patek-philippe',
    'patek-philipe': 'patek-philippe',
    patek: 'patek-philippe',
    ap: 'audemars-piguet',
    'a-p': 'audemars-piguet',
    audemars: 'audemars-piguet',
    'audemars-piguet': 'audemars-piguet',
    cartier: 'cartier',
    catier: 'cartier',
    omega: 'omega',
    tudor: 'tudor',
    panerai: 'panerai',
    'richard-mille': 'richard-mille',
    'vacheron-constantin': 'vacheron-constantin'
  };

  const goToBrandCollection = (rawBrand, useAllCollectionPath = false) => {
    const key = normalize(rawBrand);
    const handle = brandMenuHandleMap[key];
    if (!handle) return false;
    const targetUrl = useAllCollectionPath
      ? `/collections/all/${handle}?sort_by=best-selling`
      : `/collections/${handle}?sort_by=best-selling`;
    window.location.assign(targetUrl);
    return true;
  };

  document.querySelectorAll('.mega-main-btn').forEach((button) => {
    button.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (button.target && button.target !== '_self') return;

      const raw = String(button.textContent || '').replace(/^view all\s+/i, '').trim();
      if (!desktopNavQuery.matches) {
        if (!goToBrandCollection(raw, true)) return;
        event.preventDefault();
        return;
      }

      const href = String(button.getAttribute('href') || '').trim();
      if (href) {
        const brandUrl = new URL(href, window.location.origin);
        if (brandUrl.pathname.startsWith('/collections/')) {
          brandUrl.searchParams.set('sort_by', 'best-selling');
          event.preventDefault();
          window.location.assign(`${brandUrl.pathname}?${brandUrl.searchParams.toString()}`);
          return;
        }
      }

      if (!goToBrandCollection(raw)) return;
      event.preventDefault();
    });
  });

  document.querySelectorAll('.mega-sub-links a').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target && link.target !== '_self') return;

      const raw = String(link.textContent || '').replace(/^view all\s+/i, '').trim();
      if (!goToBrandCollection(raw)) return;
      event.preventDefault();
    });
  });

  document.querySelectorAll('.brand-logo-card').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (card.target && card.target !== '_self') return;

      const titleEl = card.querySelector('.brand-card-caption strong, .brand-logo-fallback strong');
      const raw = String(titleEl?.textContent || '').trim();
      if (!goToBrandCollection(raw, true)) return;

      event.preventDefault();
    });
  });

  document.addEventListener('click', (event) => {
    if (!header) return;
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-nav-button]')) return;

    const clickedInPanel = target.closest('.mega-menu, .nav-dropdown');
    if (clickedInPanel) {
      const clickedInteractive = target.closest('a, button, input, select, textarea, [role="button"]');
      if (!clickedInteractive) closeDropdowns();
      return;
    }

    closeDropdowns();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDropdowns();
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 901px)').matches) {
      if (header) header.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      closeDropdowns();
    }
  });

  closeDropdowns();

  // Announcement slider
  const announcementSliders = document.querySelectorAll('[data-announcement-slider]');

  announcementSliders.forEach((slider) => {
    const items = Array.from(slider.querySelectorAll('[data-announcement-item]'));
    if (!items.length) return;

    const prevButton = slider.querySelector('[data-announcement-prev]');
    const nextButton = slider.querySelector('[data-announcement-next]');
    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const intervalMs = Number(slider.dataset.interval) || 4000;

    let currentIndex = items.findIndex((item) => item.classList.contains('is-active'));
    if (currentIndex < 0) currentIndex = 0;
    let timerId = null;

    const setItem = (index) => {
      const boundedIndex = (index + items.length) % items.length;
      currentIndex = boundedIndex;

      items.forEach((item, i) => {
        const active = i === boundedIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    };

    const stopAutoplay = () => {
      if (!timerId) return;
      clearInterval(timerId);
      timerId = null;
    };

    const startAutoplay = () => {
      if (!autoplayEnabled || items.length < 2) return;
      stopAutoplay();
      timerId = setInterval(() => setItem(currentIndex + 1), intervalMs);
    };

    prevButton?.addEventListener('click', () => {
      setItem(currentIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      setItem(currentIndex + 1);
      startAutoplay();
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', (event) => {
      if (!slider.contains(event.relatedTarget)) startAutoplay();
    });

    setItem(currentIndex);
    startAutoplay();
  });

  // Hero slider
  const heroSliders = document.querySelectorAll('[data-hero-slider]');

  heroSliders.forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-slide]'));
    if (!slides.length) return;

    const dots = Array.from(slider.querySelectorAll('[data-slide-dot]'));
    const prevButton = slider.querySelector('[data-slide-prev]');
    const nextButton = slider.querySelector('[data-slide-next]');
    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const intervalMs = Number(slider.dataset.interval) || 5000;

    let currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (currentIndex < 0) currentIndex = 0;
    let timerId = null;

    const setSlide = (index) => {
      const boundedIndex = (index + slides.length) % slides.length;
      currentIndex = boundedIndex;

      slides.forEach((slide, i) => {
        const active = i === boundedIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, i) => {
        const active = i === boundedIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const stopAutoplay = () => {
      if (!timerId) return;
      clearInterval(timerId);
      timerId = null;
    };

    const startAutoplay = () => {
      if (!autoplayEnabled || slides.length < 2) return;
      stopAutoplay();
      timerId = setInterval(() => setSlide(currentIndex + 1), intervalMs);
    };

    prevButton?.addEventListener('click', () => {
      setSlide(currentIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      setSlide(currentIndex + 1);
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.slideIndex);
        if (Number.isNaN(index)) return;
        setSlide(index);
        startAutoplay();
      });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', (event) => {
      if (!slider.contains(event.relatedTarget)) startAutoplay();
    });

    setSlide(currentIndex);
    startAutoplay();
  });

  // Prefill contact message
  const contactBodyField = document.querySelector('[data-contact-message]');
  if (contactBodyField && !contactBodyField.value.trim()) {
    const params = new URLSearchParams(window.location.search);
    const presetMessage = params.get('message');
    const productUrl = params.get('product_url');
    const productTitle = params.get('product_title');

    if (presetMessage) {
      contactBodyField.value = presetMessage;
    } else if (productUrl || productTitle) {
      const lines = ['Hi ChronoChong,', '', 'I would like a quote for this watch:'];
      if (productUrl) lines.push(productUrl);
      if (productTitle) lines.push('', `Product: ${productTitle}`);
      contactBodyField.value = lines.join('\n');
    }
  }

  // Reveal animation
  document.documentElement.classList.add('theme-js-ready');
  const staggerGroups = Array.from(document.querySelectorAll('[data-reveal-stagger]'));

  staggerGroups.forEach((group) => {
    Array.from(group.children).forEach((child, index) => {
      child.style.setProperty('--reveal-delay', `${Math.min(index * 70, 420)}ms`);
    });
  });

  const revealTargets = [
    ...Array.from(document.querySelectorAll('[data-reveal]')),
    ...staggerGroups
  ];

  if (revealTargets.length) {
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.16,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      revealTargets.forEach((target) => revealObserver.observe(target));
    } else {
      revealTargets.forEach((target) => target.classList.add('is-visible'));
    }
  }
  } catch (error) {
    console.error('theme.js runtime error:', error);
    document.documentElement.classList.remove('theme-js-ready');
    showRevealFallback();
  }
});
